import React from 'react'
import * as Contentful from 'contentful'
import { ContentProps } from '@components/renderer'
import { Typography } from '@grammarly/badger-ui'
import { ShareLinkButton } from './share-link-button'
import { SocialShareButton } from './social-share-button'
import { SocialShareData, SocialShareType } from './types'
import { getCurrentLocation } from '@lib/utils/url'
import styles from './social-share-widget.module.scss'

interface TypeShareWidgetFields {
  internalName: Contentful.EntryFields.Symbol
  socials: SocialShareType[]
  shareLink?: Contentful.EntryFields.Text
  label?: Contentful.EntryFields.Symbol
  text?: Contentful.EntryFields.Text
  hashtags?: Contentful.EntryFields.Text
  instagramLink?: Contentful.EntryFields.Text
}

export type TypeSocialShareWidget = Contentful.Entry<TypeShareWidgetFields>

export const SocialShareWidget: React.FC<ContentProps<TypeSocialShareWidget>> = ({ structure }) => {
  const {
    fields: { label, text, hashtags, instagramLink, shareLink, socials = [] },
  } = structure

  const url = getCurrentLocation()

  // shareLink is shortened link, that we want to share, but since it's optional, we could use fallback with full url
  const shareLinkUrl = shareLink ? shareLink : url

  const shareData: SocialShareData = { url: shareLinkUrl, text, hashtags, instagramLink }

  return (
    <div className={styles.container}>
      {label && (
        <Typography.TL bold={true} as="div">
          {label}
        </Typography.TL>
      )}

      <div className={styles.socials}>
        {socials.map((type) => (
          <SocialShareButton key={type} type={type} data={shareData} />
        ))}
        <ShareLinkButton link={shareLinkUrl} />
      </div>
    </div>
  )
}
